/**
 * [INPUT]: 依赖同模块代码与项目公共基础设施能力
 * [OUTPUT]: 对外提供 index 相关实现
 * [POS]: 位于 jeepay-ui\jeepay-ui-cashier\src\config，配置装配层，负责基础设施与参数绑定
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
/*
 *  全局定义信息
 *
 *  @author terrfly
 *  @site https://www.jeepay.vip
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
const passGuardRouteList = [errorPageRouteName]  // 不进入路由守卫的name

/** 定义支付方式 **/
const payWay = {
    WXPAY : {wayCode: "WX_JSAPI", routeName: "CashierWxpay"},
    ALIPAY : {wayCode: "ALI_JSAPI", routeName: "CashierAlipay"}
}

export default {
    errorPageRouteName: errorPageRouteName,
    passGuardRouteList: passGuardRouteList,
    urlTokenName: "jeepayToken", //URL传递的token名称
    payWay: payWay,
    cacheToken: ""
}